import { BillingPeriod } from "../types/enums/BillingPeriod";

export const mapBillingPeriodToMonths = (
  billingPeriod: BillingPeriod,
): number => {
  switch (billingPeriod) {
    case BillingPeriod.MONTHLY:
      return 1;
    case BillingPeriod.QUARTERLY:
      return 3;
    case BillingPeriod.YEARLY:
      return 12;
    case BillingPeriod.TWO_YEARS:
      return 24;
    case BillingPeriod.THREE_YEARS:
      return 36;
    case BillingPeriod.FOUR_YEARS:
      return 48;
    case BillingPeriod.FIVE_YEARS:
      return 60;
    default:
      throw new Error(`Unsupported billing period: ${billingPeriod}`);
  }
};
